import React from 'react';
import {
    Route as ReactDOMRoute,
    Redirect
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

const Route = ({ isPrivate= false, component: Component, ...props }) => {
    const { user } = useAuth();

    return (
        <ReactDOMRoute
            {...props}
            render={({ location }) => {
                return isPrivate === !!user ? (
                    <Component />
                ) : (
                    <Redirect
                        to={{
                            pathname: isPrivate ? '/login' : '/',
                            state: { from: location }
                        }}
                    />
                )
            }}
        />
    );
};

export default Route;
